import { SoundType } from "../models/sounds.models";

export namespace SoundsActions {
    export class PlaySound {
        public static readonly type = "[Sounds] Play sound";
        constructor(public soundType: SoundType, public shouldLoop = false, public shouldReplayOnNoInteractionError = false) {}
    }

    export class StopSound {
        public static readonly type = "[Sounds] Stop sound";
        constructor(public soundType: SoundType) {}
    }

    export class PauseSound {
        public static readonly type = "[Sounds] Pause sound";
        constructor(public soundType: SoundType) {}
    }

    export class SetVolume {
        public static readonly type = "[Sounds] Set volume";
        constructor(public volume: number) {}
    }

    export class SoundPlayError {
        public static readonly type = "[Sounds] Sound play error";
        constructor(
            public soundType: SoundType,
            public error: unknown,
            public shouldReplayOnNoInteractionError: boolean,
            public shouldLoopReplay: boolean
        ) {}
    }

    export class SetFirstInteractionErrorHandlerCallback {
        public static readonly type = "[Sounds] Set first interaction error handler";
        constructor(public callback: () => void) {}
    }
}
